import { appConstantSettings } from 'srcReact/appConstantSettings'
import { commonActions } from 'srcReact/components'
import { myHomeConstants as mh } from 'srcReact/MyHomePage'
import { myHomeService, generalService, groupHomeService } from 'srcReact/services'
import { isEventTimeDiffLessThan5minutes } from 'srcReact/helpers/datetimeHelper'

const PAGINATION_QUANTITY = appConstantSettings.PAGINATION_QUANTITY
const MIXR_PAGINATION_QUANTITY = appConstantSettings.MIXR_PAGINATION_QUANTITY

export const myhomeActions = {
  getMyHomeAll,
  getMyHomeMixrFutureList,
  getMyHomeMixrFutureListPagination,
  getMyHomeSuggestedMixrs,
  getMyHomeMixrPastList,
  getMyHomeGroupList,
  getMyHomeSuggestedGroups,
  getAllInvitations,
  setGroupRole,
  updateRSVPData
}

function setGroupRole(joinedGroup, groupId) {
  return {
    type: mh.SET_GROUP_ROLE,
    joinedGroup,
    groupId
  }
}

function getMyHomeAll(
  id_workplace,
  latitude = 0,
  longitude = 0,
  future_mixr_list_offset = 0,
  future_mixr_list_quantity = MIXR_PAGINATION_QUANTITY,
  past_mixr_list_offset = 0,
  past_mixr_list_quantity = PAGINATION_QUANTITY,
  group_list_offset = 0,
  group_list_quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(
      request({
        id_workplace,
        latitude,
        longitude,
        future_mixr_list_offset,
        future_mixr_list_quantity,
        past_mixr_list_offset,
        past_mixr_list_quantity,
        group_list_offset,
        group_list_quantity
      })
    )

    myHomeService
      .getMyHomeAll(
        id_workplace,
        latitude,
        longitude,
        future_mixr_list_offset,
        future_mixr_list_quantity,
        past_mixr_list_offset,
        past_mixr_list_quantity,
        group_list_offset,
        group_list_quantity
      )
      .then(
        (response) => {
          response.future_mixr_list.map((m) =>
            Object.assign(m, { mixr_over: false, pagination: future_mixr_list_offset })
          )
          response.future_mixr_list.map((m) => {
            if (!m?.mixr_over && (m?.mixr_attending_type === 'virtual' || m?.mixr_attending_type === 'both')) {
              Object.assign(m, {
                is_join_call_button: isEventTimeDiffLessThan5minutes(
                  m.event_utc_start_datetime,
                  appConstantSettings.CTA_BUTTON_JOIN_CALL
                )
              })
            }
          })
          response.past_mixr_list.map((m) => Object.assign(m, { mixr_over: true, pagination: past_mixr_list_offset }))
          dispatch(success(response))
        },
        (error) => {
          dispatch(failure(error))
        }
      )
  }

  function request(data) {
    return { type: mh.GET_MYHOME_ALL_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_MYHOME_ALL_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_MYHOME_ALL_FAILURE, error }
  }
}

function getMyHomeMixrFutureList(
  id_workplace,
  latitude = 0,
  longitude = 0,
  offset = 0,
  is_mixr_over = 0,
  quantity = MIXR_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, latitude, longitude, is_mixr_over, offset, quantity }))

    myHomeService.getMixrList(id_workplace, latitude, longitude, is_mixr_over, offset, quantity).then(
      (response) => {
        response.map((m) => Object.assign(m, { mixr_over: false, pagination: offset }))
        response.map((m) => {
          if (!m?.mixr_over && (m?.mixr_attending_type === 'virtual' || m?.mixr_attending_type === 'both')) {
            Object.assign(m, {
              is_join_call_button: isEventTimeDiffLessThan5minutes(
                m.event_utc_start_datetime,
                appConstantSettings.CTA_BUTTON_JOIN_CALL
              )
            })
          }
        })
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mh.GET_MYHOME_MIXR_FUTURE_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_MYHOME_MIXR_FUTURE_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_MYHOME_MIXR_FUTURE_LIST_FAILURE, error }
  }
}

function getMyHomeMixrFutureListPagination(
  id_workplace,
  latitude = 0,
  longitude = 0,
  offset = 0,
  is_mixr_over = 0,
  quantity = MIXR_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, latitude, longitude, is_mixr_over, offset, quantity }))

    myHomeService.getMixrList(id_workplace, latitude, longitude, is_mixr_over, offset, quantity).then(
      (response) => {
        response.map((m) => Object.assign(m, { mixr_over: false, pagination: offset }))
        response.map((m) => {
          if (!m?.mixr_over && (m?.mixr_attending_type === 'virtual' || m?.mixr_attending_type === 'both')) {
            Object.assign(m, {
              is_join_call_button: isEventTimeDiffLessThan5minutes(
                m.event_utc_start_datetime,
                appConstantSettings.CTA_BUTTON_JOIN_CALL
              )
            })
          }
        })
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mh.GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_MYHOME_MIXR_FUTURE_LIST_PAGINATION_FAILURE, error }
  }
}

function getMyHomeMixrPastList(
  id_workplace,
  latitude = 0,
  longitude = 0,
  offset = 0,
  is_mixr_over = 1,
  quantity = MIXR_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, latitude, longitude, is_mixr_over, offset, quantity }))

    myHomeService.getMixrList(id_workplace, latitude, longitude, is_mixr_over, offset, quantity).then(
      (response) => {
        response.map((m) => Object.assign(m, { mixr_over: true, pagination: offset }))
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mh.GET_MYHOME_MIXR_PAST_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_MYHOME_MIXR_PAST_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_MYHOME_MIXR_PAST_LIST_FAILURE, error }
  }
}

function getMyHomeSuggestedMixrs(
  id_workplace,
  latitude = 0,
  longitude = 0,
  offset = 0,
  quantity = MIXR_PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, latitude, longitude, offset, quantity }))

    myHomeService.getMyHomeSuggestedMixrs(id_workplace, latitude, longitude, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mh.GET_MYHOME_SUGGESTED_MIXRS_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_MYHOME_SUGGESTED_MIXRS_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_MYHOME_SUGGESTED_MIXRS_FAILURE, error }
  }
}

function getMyHomeGroupList(id_workplace, latitude = 0, longitude = 0, offset = 0, quantity = PAGINATION_QUANTITY) {
  return (dispatch) => {
    dispatch(request({ id_workplace, latitude, longitude, offset, quantity }))
    myHomeService.getGroupList(id_workplace, latitude, longitude, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mh.GET_MYHOME_GROUP_LIST_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_MYHOME_GROUP_LIST_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_MYHOME_GROUP_LIST_FAILURE, error }
  }
}

function getMyHomeSuggestedGroups(
  id_workplace,
  latitude = 0,
  longitude = 0,
  offset = 0,
  quantity = PAGINATION_QUANTITY
) {
  return (dispatch) => {
    dispatch(request({ id_workplace, latitude, longitude, offset, quantity }))
    myHomeService.getMyHomeSuggestedGroups(id_workplace, latitude, longitude, offset, quantity).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mh.GET_MYHOME_SUGGESTED_GROUPS_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_MYHOME_SUGGESTED_GROUPS_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_MYHOME_SUGGESTED_GROUPS_FAILURE, error }
  }
}

function updateRSVPData(mixrId, rsvpData, pagination) {
  return { type: mh.UPDATE_RSVP_DATA, mixrId, rsvpData, pagination }
}

function getAllInvitations(id_workplace) {
  return (dispatch) => {
    dispatch(request({ id_workplace }))

    myHomeService.getAllInvitations(id_workplace).then(
      (response) => {
        dispatch(success(response))
      },
      (error) => {
        dispatch(failure(error))
      }
    )
  }

  function request(data) {
    return { type: mh.GET_ALL_INVITATIONS_REQUEST, data }
  }
  function success(data) {
    return { type: mh.GET_ALL_INVITATIONS_SUCCESS, data }
  }
  function failure(error) {
    return { type: mh.GET_ALL_INVITATIONS_FAILURE, error }
  }
}
